export interface RegisterRequest {
  email: string;
  phone: string;
  password: string;
}

export const registerRequestOutputTransformer = (request: RegisterRequest) => ({
  email: request.email,
  phone: request.phone,
  password: request.password,
});
